export const platform = {
  isBrowser: typeof window !== "undefined",
  canExit: false,
  version: "0.1.0"
};
